export default __webpack_public_path__ + "static/media/king_of_hearts2.67c7a876.png";